import React from 'react';
import type { ImageAsset } from '@sanity/types';
import { Image } from '@/components';

interface ImageWithAlt {
  alt?: string;
  image: {
    asset: ImageAsset;
  };
}

interface FullWidthImageBlockProps {
  featuredImage: ImageWithAlt;
  showOnSmallScreens?: boolean;
}

const FullWidthImageBlock: React.FC<FullWidthImageBlockProps> = ({
  featuredImage,
  showOnSmallScreens,
}) => {
  return (
    <div className={`relative max-h-[445px] ${showOnSmallScreens ? '' : 'hidden md:block'}`}>
      <Image
        image={featuredImage?.image}
        alt={featuredImage?.alt}
        className='h-[445px] w-full object-cover'
      />
    </div>
  );
};

export default FullWidthImageBlock;
